import { Box, Button, Divider, Flex, Input, Text } from '@lego/klik-ui';
import { type ReactNode, useState } from 'react';
import { BreadCrumb } from './BreadCrumb';
import { TextHeader } from './headers/TextHeader';
import { type DeviceScan, QrScanner } from './QrReader';

type DeviceActionScannerProps = {
  title: string;
  instructionText: ReactNode;
  breadcrumbs?: Array<{ label: string; path: string }>;
  children: (scan: DeviceScan, resetScan: () => void) => ReactNode;
};

export const DeviceActionScanner = ({
  title,
  instructionText,
  breadcrumbs,
  children,
}: DeviceActionScannerProps) => {
  const [scan, setScan] = useState<DeviceScan | undefined>(undefined);
  const [serialNumber, setSerialNumber] = useState('');

  const handleManualSubmit = () => {
    if (serialNumber.trim()) {
      setScan({
        macAddresses: [],
        raw: serialNumber,
        serialNumber: serialNumber.trim(),
        isManual: true,
      });
    }
  };

  const resetScan = () => {
    setScan(undefined);
    setSerialNumber('');
  };

  return (
    <Flex alignItems={'center'} justifyContent={'center'}>
      <Box maxWidth="30rem" paddingX={4}>
        {breadcrumbs && <BreadCrumb crumbs={breadcrumbs} />}
        {title && <TextHeader mb={4} mt={8} tagLevel="h2" title={title} />}
        {!scan ? (
          <Box>
            <Text fontSize={'lg'} fontWeight={'medium'} mb={4}>
              {instructionText}
            </Text>
            <Input
              onChange={(e) => setSerialNumber(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  handleManualSubmit();
                }
              }}
              placeholder="Serial number"
              value={serialNumber}
            />
            <Button
              isDisabled={!serialNumber.trim()}
              mt={4}
              onClick={handleManualSubmit}
              width="full"
            >
              Continue
            </Button>
            <Box padding="10" position="relative">
              <Divider></Divider>
              <Box
                backgroundColor="#D9D9D9"
                left="50%"
                paddingX="2em"
                position="absolute"
                textTransform="uppercase"
                transform="translate(-50%, -50%)"
              >
                or
              </Box>
            </Box>
            <QrScanner onScan={setScan} />
          </Box>
        ) : (
          children(scan, resetScan)
        )}
      </Box>
    </Flex>
  );
};
